module.exports = __webpack_public_path__ + "img/lt.7fc1ec8d.svg";